import { BaseResponse } from 'domain/payload/response/BaseResponseDto';
import axiosInstance from 'config/AxiosConfig'
import { useSelector } from 'react-redux';

const AuthService = () => {
  const { token } = useSelector((state: any) => state.auth);
  
  const sendDashboardUrl = async (emailOrPhone: string): Promise<BaseResponse<any>> => {
    try {
      var request = {
        emailOrPhone: emailOrPhone
      }
      const response = await axiosInstance.post(
        `/v1/legacy/auth/web/send-dashboard-url`,
        request
      );

      return response.data

    } catch (error: any) {
      console.error(error.response?.data?.message);
      throw error.response?.data?.message;
    }
  };

  const decodeDashboardWeb = async (sessionId: string): Promise<BaseResponse<any>> => {
    try {
      var request = {
        sessionId: sessionId
      }
      const response = await axiosInstance.post(
        `/v1/legacy/auth/web/decode-session`,
        request
      );

      return response.data

    } catch (error: any) {
      console.error(error.response?.data?.message);
      throw error.response?.data?.message;
    }
  };

  return { sendDashboardUrl, decodeDashboardWeb };
};

export default AuthService;